module.exports = __webpack_public_path__ + "static/media/ananta.c18d2024.png";